define(["underscore", "jquery", "i18n/i18n"], function (_, $, i18n) {
      
    var calculateFloatingDivPosition = function (options) {
      var x = $(options.event.target).offset().left + 10;
      var y = $(options.event.target).offset().top + 10;
      var floatingDivWidth = 500;
      var windowWidth = window.innerWidth;
          
      // Adjust x-position if the floating div would overflow on the right
      if (x + floatingDivWidth > windowWidth) {
        x = windowWidth - floatingDivWidth - 10;
      } 
      return { xPos: x, yPos: y };
    }

    var  appendCopyPathMessageBox = function (message, icon, color, shortPath , xPos , yPos) {
      var $copyPathModal = $('<div>').addClass('mb-copy-path-modal');
      $copyPathModal.html(
        "<i data-action-name='removeCopyPathModal' class='mb-close-copy-path-modal icon-remove-sign action'></i>" +
        "<div class='mb-message-container'>" +
          "<p class='mb-message'>"+ message + "<\/p><i class='" + icon + " " + color + "'></i>"+
        "</div>"+
        "<p class='mb-path'>..." + shortPath + "</p>");         
        $copyPathModal.css({
        top: yPos + 'px',
        left: xPos + 'px'
      });
     
      $('body').append($copyPathModal);
    }

    var _removeCopyPathModal = function (event) {
      var clickedElm = $(event.target);
      var isNotModal = (event.type === "click" && clickedElm && clickedElm.parents(".mb-copy-path-modal").length <= 0 && !event.target.classList.contains("mb-copy-path-modal"));
      if (event.type === "scroll" || isNotModal) {
        removeCopyPathModal();
      }        
    };

    function removeCopyPathModal () {
      $(".mb-copy-path-modal").remove();
      document.body.removeEventListener("click", _removeCopyPathModal, true);
      window.removeEventListener("scroll", _removeCopyPathModal, true);
    }

    function copyPathActionHandler (options) {
      try {
        var path = options["mb:absoluteDocumentUrl"].replace(/\//g,"\\");
        var position = calculateFloatingDivPosition(options);
       
        if (!position.xPos || position.xPos < 0) {
          position.xPos = 9;
        }
        
        var xPos = position.xPos;
        var yPos = position.yPos;       
      
        var failedMsg = i18n("copy_path_failed_msg");
        
        if (path) {
          path = path.split("\\");
         
          if(path.length === 0){
            appendCopyPathMessageBox(i18n("copy_path_failed"), 'icon-ban-circle', 'danger', failedMsg, xPos, yPos);
            return;
          } else if (path.length < 2) {
            path = path.slice(-1);
          } else if (path.length < 3) {
            path = path.slice(-2);
          } else {
            path = path.slice(-3);
          }

          path = path.join("\\")
          var copyPath = options["mb:absoluteDocumentUrl"].replace(/\//g,"\\")
          navigator.clipboard.writeText("\\\\"+copyPath).then(function() {
            appendCopyPathMessageBox(i18n("copy_path"), 'icon-ok', 'success' , path, xPos, yPos);
          }).catch(function(err) {
            appendCopyPathMessageBox(i18n("copy_path_failed"), 'icon-ban-circle', 'danger', failedMsg, xPos, yPos);
          });
        
        } else {
          appendCopyPathMessageBox(i18n("copy_path_failed"), 'icon-ban-circle', 'danger', failedMsg, xPos, yPos);
        }
        
        document.body.addEventListener("click", _removeCopyPathModal, true);
        window.addEventListener("scroll", _removeCopyPathModal, true);
      } catch (error) {
        appendCopyPathMessageBox(i18n("copy_path_failed"), 'icon-ban-circle', 'danger', failedMsg, xPos, yPos);
      }
    }

    return {
      actionHandler : copyPathActionHandler,
      removeModal : removeCopyPathModal
    }
})